// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleDataModelAccess.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action, observable, computed } from 'mobx';
import { isEmpty } from 'lodash/fp';
import tracker from 'share/tracking/Izenda.Tracker';

@tracker
export default class RoleDataModelAccess {
  @observable displayData: Array<any> = [];
  @observable connectionList: Array<any> = [];
  @observable filterText: string = '';
  @observable showCheckedQuerySource: boolean = false;

  @computed
  get hasChange() {
    return this.isDirty || !isEmpty(this.visibleQuerySourcesTree);
  }

  constructor(roleDetail: any) {
    this.isLastPage = false;
    this.visibleQuerySources = [];
    this.roleDetail = roleDetail;
    this.visibleQuerySourcesTree = [];
  }

  /**
   * Set show checked query source
   * @param {boolean} checked
   */
  @action
  setShowCheckedQuerySource(checked: boolean) {
    this.markDirty();
    this.showCheckedQuerySource = checked;
  }

  /**
   * Reset data model access
   * @param  {string} type
   */
  @action
  reset() {
    this.resetDirty();
    this.resetCacheTree();
    this.resetData();
    this.filterText = '';
    this.showCheckedQuerySource = false;
  }

  /**
   * Reset cache tree
   */
  @action
  resetCacheTree() {
    this.resetDirty();
    this.visibleQuerySourcesTree.length = 0;
  }

  /**
   * Reset data tree
   */
  @action
  resetData() {
    this.displayData.length = 0;
    this.connectionList.length = 0;
  }

  /**
   * Read role data model access from data that normally returns from server API
   * @method readData
   * @param {array} data List Of connection
   */
  @action
  readData(data: any) {
    this.connectionList = data;
  }

  /**
   * Convert data
   * @type {Array}
   */
  convertData(data: Array<any>): Array<any> {
    return observable(data);
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.RoleDataModelAccess.js